import * as http from '../api/http'
import {CATALOGOS_TYPES} from '../constants/catalogos.types'
import {generalOpenModalError, generalShowLoader} from './general.actions'
import {Dispatch} from 'react'
import {ENDPOINTS} from '../api/config'
import {CatalogoAction} from '../interfaces/catalogos.interface'
import {State} from '../reducers'

// SETTERS ---------------------------------------------------------------
export const handleSetCondicionesPago = (condiciones: any) => ({type: CATALOGOS_TYPES.CATALOGO_SET_CONDICIONES_PAGO, payload: condiciones})
export const handleSetFormasPago = (formas: any) => ({type: CATALOGOS_TYPES.CATALOGO_SET_FORMAS_PAGO, payload: formas})
export const handleSetPlazosPago = (plazos: any) => ({type: CATALOGOS_TYPES.CATALOGO_SET_PLAZOS_PAGO, payload: plazos})
export const handleSetTipoCargosMembresia = (cargos: any) => ({type: CATALOGOS_TYPES.CATALOGO_SET_TIPO_CARGOS_MEMBRESIA, payload: cargos})
export const handleSetProductos = (productos: any) => ({type: CATALOGOS_TYPES.CATALOGO_SET_PRODUCTOS, payload: productos})

export const setDepartamentos = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_DEPARTAMENTOS,
  payload: value,
})
export const setMunicipios = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_MUNICIPIOS,
  payload: value,
})
export const setPlanFacturas = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_PLANFACTURAS,
  payload: value,
})
export const setTipoEstablecimientos = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_TIPO_ESTABLECIMIENTOS,
  payload: value,
})
export const setTipoPersona = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_TIPO_PERSONA,
  payload: value,
})
export const setActividadesEconomicas = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_ACTIVIDADES_ECONOMICAS,
  payload: value,
})
export const setTiposDocumento = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_TIPO_DOCUMENTO,
  payload: value,
})
export const setUnidadesMedida = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_UNIDADES_MEDIDA,
  payload: value,
})
export const setTiposDocumentoEmision = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_TIPO_DOCUMENTOS_EMISION,
  payload: value,
})
export const setDatosGeneralesEmisor = (datos: any) => ({
  type: CATALOGOS_TYPES.GENERAL_DATOS_EMISOR,
  payload: datos,
})
export const setCatalogoBotonesAyuda = (data: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_BOTONES_AYUDA,
  payload: data
})
export const setCatalogoBancos = (data: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_BANCOS,
  payload: data
})
export const setCatalogoCondicionOperacionCat016 = (data: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_CONDICION_OPERACION_CAT016,
  payload: data
})

export const catalogosClear = () => ({
  type: CATALOGOS_TYPES.CATALOGOS_CLEAR,
  payload: null,
})

export const setServiciosAdicionales = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_SERVICIOS_ADICIONALES,
  payload: value,
})
export const setImpuestosDistintosAlIva = (value: any) => ({
  type: CATALOGOS_TYPES.CATALOGO_SET_IMPUESTOS,
  payload: value,
})
// GETS -----------------------------------------------------------------
export const getBancos =
  () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
    if (getState().catalogos.bancos.length > 0) return true
    return await http
      .get(ENDPOINTS.GET_BANCOS)
      .then(async (res: any) => {
        if (res?.data) {
          dispatch(setCatalogoBancos(res?.data))
          return true
        } else {
          dispatch(
            generalOpenModalError('No hay bancos disponibles para realizar operaciones')
          )
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de bancos, intente nuevamente'
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
  }

  export const getServiciosAdicionales =
  () => async (dispatch: Dispatch<CatalogoAction>) => {
    return await http
      .get(ENDPOINTS.GET_SERVICIOS_ADICIONALES)
      .then((res: any) => {
        
        if (res?.data) {
          dispatch(setServiciosAdicionales(res?.data));
          return true;
        } else {
          dispatch(generalOpenModalError('No hay servicios adicionales realizar operaciones'))
          return false;
        }
      })
      .catch((err: any) => {
        let message = 'Error al cargar catalogo de servicios adicionales, intente nuevamente'
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
  }

export const getDepartamentos =
  () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
    if (getState().catalogos.departamentos.length > 0) return true
    return await http
      .get(ENDPOINTS.GET_DEPARTAMENTOS)
      .then(async (res: any) => {
        if (res.body) {
          dispatch(setDepartamentos(res.body))
          return true
        } else {
          dispatch(
            generalOpenModalError('No hay departamentos disponibles para realizar operaciones')
          )
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de departamentos, intente nuevamente'
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
  }
export const getMunicipios =
  (idDepartamento: number, depa: string, loader: boolean = false) =>
  async (dispatch: Dispatch<CatalogoAction>) => {
    if (loader) dispatch(generalShowLoader(true))
    return await http
      .post(ENDPOINTS.GET_MUNICIPIOS, {
        codigo: idDepartamento < 10 ? '0' + idDepartamento : idDepartamento,
        valor: depa,
      })
      .then(async (res: any) => {
        if (res.body) {
          dispatch(setMunicipios(res.body))
          return true
        } else {
          dispatch(generalOpenModalError('No hay municipios disponibles para realizar operaciones'))
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de municipios, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message,err?.response?.data?.status))
        return false
      })
      .finally(() => {
        if (loader) dispatch(generalShowLoader(false))
      })
  }
export const getPlanFacturas = () => async (dispatch: Dispatch<CatalogoAction>) => {
  return await http
    .get(ENDPOINTS.GET_PLANFACTURAS)
    .then(async (res: any) => {
      if (res.data) {
        dispatch(setPlanFacturas(res.data))
        return true
      } else {
        dispatch(
          generalOpenModalError('No hay plan de facturas disponibles para realizar operaciones')
        )
        return false
      }
    })
    .catch(async (err: any) => {
      let message = 'Error al cargar catalogo de plan de facturas, intente nuevamente'
      await dispatch(
        generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status)
      )
      return false
    })
}
export const getActividadesEconomicas =
  () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
    if (getState().catalogos.actividadesEconomicas.length > 0) return true
    return await http
      .get(ENDPOINTS.GET_ACTIVIDAD_ECONOMICA)
      .then(async (res: any) => {
        if (res.body) {
          let response = res?.body?.filter((act: any) => act?.codigo?.trim() !== '')
          dispatch(setActividadesEconomicas(response))
          return true
        } else {
          dispatch(generalOpenModalError('No hay actividades económicas para realizar operaciones'))
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de actividades económicas, intente nuevamente'
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
  }
export const getTipoEstablecimiento =
  () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
    if (getState().catalogos.tipoEstablecimientos.length > 0) return true
    return await http
      .get(ENDPOINTS.GET_TIPO_ESTABLECIMIENTOS)
      .then(async (res: any) => {
        if (res.body) {
          dispatch(setTipoEstablecimientos(res.body))
          return true
        } else {
          dispatch(
            generalOpenModalError('No hay tipos de establecimientos para realizar operaciones')
          )
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de tipos de establecimientos, intente nuevamente'
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
  }

export const getTipoPersona = () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if (getState().catalogos.tipoEstablecimientos.length > 0) return true
    return await http
      .get(ENDPOINTS.GET_TIPO_PERSONA)
      .then(async (res: any) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          dispatch(setTipoPersona(res.data))
          return true
        } else {
          dispatch(
            generalOpenModalError('No hay tipos de persona disponibles')
          )
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de tipos de persona, intente nuevamente'
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
}

export const getSuscripciones =
  () => async (dispatch: Dispatch<CatalogoAction>) => {
    return await http
      .get(ENDPOINTS.GET_SUSCRIPCIONES)
      .then((res: any) => {
        if (res?.body) {
          dispatch(setPlanFacturas(res?.body));
          return true;
        } else {
          dispatch(generalOpenModalError('No hay tipos de suscripciones para realizar operaciones'))
          return false;
        }
      })
      .catch((err: any) => {
        let message = 'Error al cargar catalogo de tipos de suscripciones, intente nuevamente'
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
  }

export const getUnidadesMedida = () => async(dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if(getState().catalogos.unidadesMedida.length > 0) return true

  try {
    const response: any = await http.get(ENDPOINTS.GET_UNIDAD_MEDIDA)
    if(Array.isArray(response.body) && response.body.length > 0){
      dispatch(setUnidadesMedida(response.body))
      return true
    } else {
      dispatch(generalOpenModalError(response?.message ?? 'No se encontraron unidades de medida para realizar operaciones, recarga la página'))
      return false
    }
  } catch (error: any) {
    let message = 'Ocurrió un error al cargar el catálogo de Unidades de Medida'
    dispatch(generalOpenModalError(error?.response?.data?.message ?? message, error?.response?.data?.status))
  }
}

export const getImpuestosProducto = () => async(dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if(getState().catalogos.impuestosProducto.length > 0 ) return true

  try {
    const response: any = await http.get(ENDPOINTS.GET_IMPUESTOS_PRODUCTO)
    if(Array.isArray(response.body) && response.body.length > 0){
      dispatch(setImpuestosDistintosAlIva(response.body))
      return true
    } else {
      dispatch(generalOpenModalError(response?.message ?? 'No se encontraron impuestos para realizar operaciones, recarga la página'))
      return false
    }
  } catch (error: any) {
    let message = 'Ocurrió un error al cargar el catálogo de Impuestos'
    dispatch(generalOpenModalError(error?.response?.data?.message ?? message, error?.response?.data?.status))
  }
}


export const getTiposDocumento =
  () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
    if (getState().catalogos.tipoDocumento.length > 0) return true
    return await http
      .get(ENDPOINTS.GET_TIPO_IDENTIFICACION)
      .then(async (res: any) => {
        if (res.body) {
          const docs = res.body.sort((a: any, b: any) => {
            const nombreA = a?.codigo?.toLowerCase()
            const nombreB = b?.codigo.toLowerCase()
            return nombreA < nombreB ? -1 : nombreA > nombreB ? 1 : 0
          })
          dispatch(setTiposDocumento(docs))
          return true
        } else {
          dispatch(generalOpenModalError(res?.message ?? 'No hay tipos de documento para realizar operaciones'))
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de tipos de documento'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false
      })
  }
export const getTiposDocumentoEmision =
  () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
    if (getState().catalogos.tipoDocumentosEmision.length > 0) return true
    return await http
      .get(ENDPOINTS.GET_TIPO_DOCUMENTOS)
      .then(async (res: any) => {
        if (res.data) {
          dispatch(setTiposDocumentoEmision(res.data))
          return true
        } else {
          dispatch(generalOpenModalError(res?.message ?? 'No hay tipos de documento para realizar operaciones'))
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de tipos de documento'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message,err?.response?.data?.status))
        return false
      })
  }
export const postNombreDepartamento = async (codigoDepartamento: string) => {
  let message = 'Error al obtener información del departamento'
  return await http
    .post(ENDPOINTS.GET_NOMBRE_DEPARTAMENTO, {codigo: codigoDepartamento})
    .then((res: any) => {
      if (res?.body && res.body.length > 0 && res.body[0])
        return {body: res.body[0], error: false, message: ''}
      else return {body: null, error: true, message: res?.message ?? message}
    })
    .catch((err: any) => {
      return {body: null, error: true, message: err?.response?.data?.message ?? message}
    })
}
export const postNombreMunicipio = async (codigoDepartamento: string, codigoMunicipio: string) => {
  let message = 'Error al obtener información del municipio'
  return await http
    .post(ENDPOINTS.GET_NOMBRE_MUNICIPIO, {codigoDepartamento, codigoMunicipio})
    .then((res: any) => {
      if (res?.body && res.body.length > 0 && res.body[0])
        return {body: res.body[0], error: false, message: ''}
      else return {body: null, error: true, message: res?.message ?? message}
    })
    .catch((err: any) => {
      return {body: null, error: true, message: err?.response?.data?.message ?? message}
    })
}

export const getBotonesAyuda =
  () => async (dispatch: Dispatch<CatalogoAction>) => {
    return await http.get(ENDPOINTS.GET_BOTONES_AYUDA)
    .then(async (res: any) => {
      if(res.data){
        dispatch(setCatalogoBotonesAyuda(res.data));
        return true
      } else {
        dispatch(generalOpenModalError(res.message || 'Ocurrió un error al cargar los botones de ayuda al usuario.'))
      }
    })
    .catch(async (err: any) => {
      let message = 'Error al cargar catalogo de tipos de ayuda, intente nuevamente'
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      return false;
    })
  }

export const getCondicionOperacionCAT016 =
  () => async (dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
    if (getState().catalogos.tipoDocumento.length > 0) return true
    return await http.get(ENDPOINTS.GET_CONDICION_OPERACION_CAT016).then(async (res: any) => {
        if (res.body) {
          dispatch(setCatalogoCondicionOperacionCat016(res.body))
          return true
        }
        dispatch(generalOpenModalError(res?.message ?? 'El catálogo condición de la operación no posee datos'))
        return false        
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catálogo de condición de la operación'
        await dispatch(generalOpenModalError(err?.response?.data?.message || message, err?.response?.data?.status))
        return false
      })
  }

  
export const getFormasPago = () => async(dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if(getState().catalogos.formasPago.length > 0) return true

  try {
    const response: any = await http.get(ENDPOINTS.GET_FORMA_PAGO)
    if(Array.isArray(response.body) && response.body.length > 0){
      dispatch(handleSetFormasPago(response.body))
      return true
    } else {
      dispatch(generalOpenModalError(response?.message ?? 'No se encontraron formas de pago, recarga la página'))
      return false
    }
  } catch (error: any) {
    let message = 'Ocurrió un error al cargar el catálogo de formas de pago'
    dispatch(generalOpenModalError(error?.response?.data?.message ?? message, error?.response?.data?.status))
  }
}

export const getCondicionesPago = () => async(dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if(getState().catalogos.condicionesPago.length > 0) return true

  try {
    const response: any = await http.get(ENDPOINTS.GET_CONDICION_OPERACION_CAT016)
    if(Array.isArray(response.body) && response.body.length > 0){
      dispatch(handleSetCondicionesPago(response.body))
      return true
    } else {
      dispatch(generalOpenModalError(response?.message ?? 'No se encontraron condiciones de pago, recarga la página'))
      return false
    }
  } catch (error: any) {
    let message = 'Ocurrió un error al cargar el catálogo de condiciones de pago'
    dispatch(generalOpenModalError(error?.response?.data?.message ?? message, error?.response?.data?.status))
  }
}

export const getPlazosPago = () => async(dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if(getState().catalogos.plazosPago.length > 0) return true

  try {
    const response: any = await http.get(ENDPOINTS.GET_PLAZO_PAGO)
    if(Array.isArray(response.body) && response.body.length > 0){
      dispatch(handleSetPlazosPago(response.body))
      return true
    } else {
      dispatch(generalOpenModalError(response?.message ?? 'No se encontraron plazos de pago, recarga la página'))
      return false
    }
  } catch (error: any) {
    let message = 'Ocurrió un error al cargar el catálogo de plazos de pago'
    dispatch(generalOpenModalError(error?.response?.data?.message ?? message, error?.response?.data?.status))
  }
}

export const getTiposCargoMembresia = () => async(dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if(getState().catalogos.tipoCargosMembresia.length > 0) return true

  try {
    const response: any = await http.get(ENDPOINTS.GET_TIPOS_CARGOS_MEMBRESIA)
    if(Array.isArray(response.body) && response.body.length > 0){
      dispatch(handleSetTipoCargosMembresia(response.body))
      return true
    } else {
      dispatch(generalOpenModalError(response?.message ?? 'No se encontraron cargos de membresia, recarga la página'))
      return false
    }
  } catch (error: any) {
    let message = 'Ocurrió un error al cargar el catálogo de cargos de membresia'
    dispatch(generalOpenModalError(error?.response?.data?.message ?? message, error?.response?.data?.status))
  }
}

export const getCatalogosProductos = (codigoempresa: string, idsucursal: string) => async(dispatch: Dispatch<CatalogoAction>, getState: () => State) => {
  if(getState().catalogos.productos.length > 0) return true;

  const params = {
    codigoempresa,
    idsucursal
  }

  try {
    const response: any = await http.get(ENDPOINTS.GET_PRODUCTOS, params)
    if(Array.isArray(response.data)){
      dispatch(handleSetProductos(response.data))
      return true;
    }
    return false;
  } catch (error: any) {
    let message = 'Ocurrió un error al cargar el catálogo de productos'
    dispatch(generalOpenModalError(error?.response?.data?.message ?? message, error?.response?.data?.status))
  }
}


